import { CheckCircleIcon, InformationCircleIcon, XCircleIcon, XMarkIcon } from "@heroicons/react/24/outline"
import { useSelector } from "react-redux"
import { RootState } from "../../store"
import { NotificationItemWithId, closeNotification } from "./notificationSlice"

export function NotificationStack() {
    const notifications = useSelector<RootState, NotificationItemWithId[]>(x => x.notifications.notifications);

    return (
        <div className="fixed right-0 top-16 mt-4 z-[500] flex flex-col items-end space-y-2 pr-4 md:pr-8 w-[350px]">
            {
                notifications.filter(x => x.isOpen).map((notification, index) => {
                    return <div key={notification.id} className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-secondary shadow-lg ring-1 ring-color-border">
                        <div className="p-4">
                            <div className="flex items-start">
                                <div className="flex-shrink-0">
                                    {
                                        notification.type === "success" &&
                                        <CheckCircleIcon className="h-6 w-6 text-green-400" aria-hidden="true" />
                                    }
                                    {
                                        notification.type === "failure" &&
                                        <XCircleIcon className="h-6 w-6 text-red-400" aria-hidden="true" />
                                    }
                                    {
                                        notification.type === "info" &&
                                        <InformationCircleIcon className="h-6 w-6 text-blue-400" aria-hidden="true" />
                                    }
                                </div>
                                <div className="ml-3 w-0 flex-1 pt-0.5">
                                    <p className="text-sm font-medium whitespace-pre-wrap">{notification.message}</p>
                                </div>
                                <div className="ml-4 flex flex-shrink-0">
                                    <button
                                        type="button"
                                        className="inline-flex rounded-md  text-contrast-tertiary hover:text-contrast-secondary focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                        onClick={() => {
                                            closeNotification(notification.id);
                                        }}
                                    >
                                        <span className="sr-only">Close</span>
                                        <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                })
            }
        </div>
    )
}